import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get, sampleSize } from 'lodash';
import numeral from 'numeral';

import icons from '../../../components/IconsList';
import { colors } from '../../../styles';

const styles = css`
  @media(min-width: 992px) {
    border-left: 1px solid #D3D3D3;
  }
  .HomePrice_price {
    font-weight: 700;
    font-size: 13px;
    color: #171717;
    letter-spacing: 0;
    border: 1px solid #DADADA;
    margin: 0;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media(min-width: 992px) {
      padding: 0;
      border: 0;
      font-weight: 300;
      font-size: 28px;
      color: #000000;
      line-height: 35px;
    }
  }
  .HomePrice_status {
    font-weight: 700;
    font-size: 13px;
    color: #171717;
    letter-spacing: 0;
    background-color: rgb(251, 245, 235);
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    @media(min-width: 992px) {
      padding: 0 25px;
      height: 42px;
      font-size: 17px;
    }
    @media(min-width: 1300px) {
      padding: 0 35px;
    }
  }
  .HomePrice_list {
    li {
      padding: 0 0 0 20px;
      font-size: 12px;
      color: #171717;
      letter-spacing: 0;
      background-repeat: no-repeat;
      background-position: left center;
      display: flex;
      align-items: center;
      @media(min-width: 310px) {
        font-size: 13px;
      }
      @media(min-width: 400px) {
        padding: 0 20px 0 25px;
      }
      @media(min-width: 992px) {
        font-size: 15px;
        background-size: 20px 20px;
      }
      & + li {
        margin: 0 0 0 10px;
      }
    }
  }
  .HomePrice_mls {
    border-top: 1px solid #D3D3D3;
    border-bottom: 1px solid #D3D3D3;
  }
  .HomePrice_district {
    color: ${colors.color1};
    font-weight: 700;
  }
  b {
    font-weight: 700;
    color: ${colors.text};
  }
`;

function HomePrice({ home, className, community }) {
  const randomSchool = sampleSize(get(community, 'schools', ''), 1)[0];
  let district = null;
  const text = /School District/gi;
  if (randomSchool) {
    district = get(randomSchool, 'district').replace(text, '');
  }
  let homePrice = get(home, 'price') > 0 ? `Starting at ${numeral(get(home, 'price')).format('$0,0a')}+` : 'Call for Pricing';
  homePrice = get(home, 'custom_price_display') ? get(home, 'custom_price_display') : homePrice;
  return (
    <div className={`${className} ${styles}`}>
      <div className="d-flex pt-lg-2 pl-lg-2 pl-xl-5">
        <h4 className="HomePrice_price mr-auto mr-sm-2 mr-lg-auto">
          <div><b>Price:</b>&nbsp;{homePrice}</div>
        </h4>
        {
          get(home, 'status') &&
          <span className="HomePrice_status">{`Status ${get(home, 'status') === 'Active' ? 'Move-In Ready' : get(home, 'status')}`}</span>
        }
      </div>
      <ul className="list-unstyled d-flex HomePrice_list m-0 py-3 py-lg-4 pl-lg-2 pl-xl-5">
        <li className="HomePrice_listItem" style={{ backgroundImage: `url(${icons.beds})` }}>
          <b>{get(home, 'beds')}</b>&nbsp;Beds
        </li>
        <li className="HomePrice_listItem" style={{ backgroundImage: `url(${icons.baths})` }}>
          <b>{get(home, 'bathsFull')}{get(home, 'bathsHalf', 0) > 0 ? '.5' : ''}</b>&nbsp;Baths
        </li>
        <li className="HomePrice_listItem" style={{ backgroundImage: `url(${icons.sqft})` }}>
          <b>{numeral(home.sqft).format('0,0')}</b>&nbsp;SQFT
        </li>
      </ul>
      <ul className="list-unstyled d-flex flex-wrap m-0 py-3 py-lg-4 pl-lg-2 pl-xl-5 HomePrice_mls">
        {
          get(home, 'mls') &&
          <li className="mr-2 mr-lg-3"><b>MLS</b>&nbsp;{get(home, 'mls')}</li>
        }
        {
          get(home, 'stories') &&
          <li className="mr-2 mr-lg-3"><b>{get(home, 'stories')}</b>{home.stories === 1 ? ' Story' : ' Stories'}</li>
        }
        {
          get(home, 'garages') &&
          <li className="mr-2 mr-lg-3"><b>{get(home, 'garages')}</b>-Car Garage</li>
        }
        {/* <li><b>Architect</b>&nbsp;Lorem Ipsum</li> */}
      </ul>
      <ul className="list-unstyled d-flex flex-wrap m-0 py-3 py-lg-4 pl-lg-2 pl-xl-5">
        {
          district &&
          <li className="mr-auto mr-sm-2 mr-lg-auto HomePrice_district"><b>School District</b>&nbsp;{district}</li>
        }
        {
          get(home, 'isModel') &&
          <li><b>*Furnished model home</b></li>
        }
      </ul>
    </div>
  );
}

HomePrice.propTypes = {
  home: PropTypes.object.isRequired,
  community: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default HomePrice;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeDetails/HomePrice.js